module.exports = __webpack_public_path__ + "img/avin.76c075bc.png";